// Import everything from autoload
import "./autoload/_bootstrap.js"

// eslint-disable-next-line no-unused-vars
import '@fancyapps/fancybox/dist/jquery.fancybox.min';

/**
 * @see https://api.jqueryui.com/datepicker/
 * for usage and dependencies
 */
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/effect';
import 'jquery-ui/ui/widgets/datepicker';

/*
* http://leafo.net/sticky-kit/#reference
* https://github.com/leafo/sticky-kit
 */
import 'sticky-kit/dist/sticky-kit.min';

import '../_project/scripts/ga/ga-variables.js';
import './ga/ga.js';

require('./libs/advivapress.js');

// PROJECT
require('../_project/scripts/project');





// WEBPACK FOOTER //
// ./scripts/main.js